import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import initAppBridge, { waitForShopify, shouldUseAppBridge } from './AppBridge';
import './utils/chartSetup';

function AppBridgeInitializer({ children }) {
  const [ready, setReady] = useState(!shouldUseAppBridge()); // If not using App Bridge, ready immediately

  useEffect(() => {
    if (!shouldUseAppBridge()) {
      //console.log('[AppBridgeInitializer] Not using App Bridge - skipping');
      setReady(true);
      return;
    }

    async function init() {
      const params = new URLSearchParams(window.location.search);
      const shop = params.get('shop');
      
      //console.log('[AppBridgeInitializer] Waiting for App Bridge CDN...');
      const cdnLoaded = await waitForShopify();
      
      if (cdnLoaded) {
       // console.log('[AppBridgeInitializer] CDN loaded, initializing for shop:', shop);
        const app = initAppBridge();
        
        if (app) {
          window.app = app;
          window.shopDomain = shop;
          //console.log('[AppBridgeInitializer] ✅ Initialized successfully');
        } else {
          console.warn(' Init returned null');
        }
      } else {
        console.warn(' ⚠️ CDN failed to load');
      }
      
      setReady(true);
    }
    
    init();
  }, []);

  if (!ready) {
    return <div style={{ padding: 20, textAlign: 'center' }}>Loading...</div>;
  }

  return <>{children}</>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppBridgeInitializer>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </GoogleOAuthProvider>
    </AppBridgeInitializer>
  </React.StrictMode>
);

reportWebVitals();